<style>
.deviceunlocked {
  opacity: 1;
}
.devicelocked {
  opacity: 0.4;
}

.devicedetailsbar {
  background-color: #39a9dc;
}

.devicedetailsbar :hover {
  background-color: #f44336;
}
</style>

<template>
  <v-card color="grey lighten-4" flat height="100%">
    <v-toolbar color="#39a9dc" dark>
      <v-toolbar-side-icon v-on:click="$emit('leaveView')"
        ><v-icon>close</v-icon></v-toolbar-side-icon
      >
      <v-toolbar-title>Overview</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon v-on:click="deleteDevice()">delete_forever</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <v-layout row wrap>
        <!-- General section-->
        <v-flex xs12 style="margin-bottom: 2rem">
          <v-card
            tile
            flat
            class="elevation-1"
            style="
              position: relative;
              text-align: left;
              padding-bottom: 0.4rem;
              width: 100%;
            "
          >
            <v-card-title
              class="subheading"
              style="
                margin-top: 1rem;
                border-style: solid;
                border-width: 0em 0em 0em 0.3em;
                border-color: #ffc107;
                margin-top: -0.1rem;
              "
            >
              <v-icon left>info</v-icon>
              <span class="font-weight-bold">General</span>
            </v-card-title>

            <v-card-text class="caption">
              <v-layout>
                <v-flex xs12 sm12 md6 style="padding: 1rem">
                  <v-layout style="padding: 0.5rem">
                    <v-flex xs3 class="grey--text"> Unique ID </v-flex>
                    <v-flex xs8>
                      {{ device.id }}
                    </v-flex>
                  </v-layout>

                  <v-layout style="padding: 0.5rem">
                    <v-flex xs3 class="grey--text"> Friendly label </v-flex>
                    <v-flex xs8>
                      {{ device.label }}
                    </v-flex>
                  </v-layout>

                  <v-layout style="padding: 0.5rem">
                    <v-flex xs3 class="grey--text"> Profile </v-flex>
                    <v-flex xs8 v-if="device.deviceProfileId">
                      {{ device.deviceProfileId }}
                    </v-flex>
                    <v-flex xs8 v-else class="grey--text">
                      No profile defined for this device
                    </v-flex>
                  </v-layout>

                  <v-layout style="padding: 0.5rem">
                    <v-flex xs3 class="grey--text">
                      <v-icon small>sensors</v-icon> Last activity
                    </v-flex>
                    <v-flex xs8>
                      <current-offset-date-component
                        :timestamp="device.lastActivity || 0"
                      ></current-offset-date-component>
                      <p class="grey--text caption">
                        {{ new Date(device.lastActivity) || "" }}
                      </p>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-layout justify-center>
                    <v-flex xs12>
                      <img
                        style="width: 10rem"
                        alt="Image unavailable"
                        onerror="this.style.display='none'"
                        :src="
                          '/assets/technology/' +
                            device.connectivity.replaceAll(':', '_') +
                            '.png'
                        "
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- Telemetry section -->
        <v-flex xs12 style="margin-bottom: 2rem">
          <v-card
            tile
            flat
            class="elevation-1"
            style="
              position: relative;
              text-align: left;
              padding-bottom: 0.4rem;
              width: 100%;
            "
          >
            <v-card-title
              class="subheading"
              style="
                margin-top: 1rem;
                border-style: solid;
                border-width: 0em 0em 0em 0.3em;
                border-color: #ffc107;
                margin-top: -0.1rem;
              "
            >
              <v-icon left style="margin-right: -1rem">bar_charts</v-icon>
              <span class="font-weight-bold">Last telemetry</span>
            </v-card-title>

            <v-card-text class="caption">
              <v-layout>
                <v-flex
                  xs12
                  style="padding: 1rem"
                  class="text-capitalize"
                  v-if="device.rawLastTelemetry.length > 0"
                >
                  <v-layout
                    v-for="(item, index) in device.rawLastTelemetry"
                    :key="index"
                    align-center
                  >
                    <v-flex xs3 class="grey--text">
                      <v-avatar>
                        <img
                          style="transform: scale(0.5)"
                          :src="'/assets/telemetry/' + item.t + '.png'"
                          onerror="this.style.display='none'"
                        />
                      </v-avatar>
                      {{
                        measuresAvailable.find((m) => m.id === item.t)
                          ? measuresAvailable.find((m) => m.id === item.t).label
                          : item.t
                      }}
                    </v-flex>
                    <v-flex xs8>
                      {{ item.v }}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else>
                  <div
                    class="
                      d-flex
                      transition-fast-in-fast-out
                      grey
                      lighten-4
                      v-card--reveal
                      grey--text
                      text-sm-center
                    "
                    style="
                      height: 100%;
                      width: 100%;
                      opacity: 0.5;
                      position: absolute;
                      margin-top: -1rem;
                    "
                  >
                    <p
                      style="
                        position: absolute;
                        width: 100%;
                        padding-top: 0.5rem;
                      "
                      class="text-sm-center"
                    >
                      No telemetry data available
                    </p>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- Events section -->
        <v-flex xs12 style="margin-bottom: 2rem">
          <v-card
            tile
            flat
            class="elevation-1"
            style="
              position: relative;
              text-align: left;
              padding-bottom: 0.4rem;
              width: 100%;
            "
          >
            <v-card-title
              class="subheading"
              style="
                margin-top: 1rem;
                border-style: solid;
                border-width: 0em 0em 0em 0.3em;
                border-color: #ffc107;
                margin-top: -0.1rem;
              "
            >
              <v-icon left>flash_on</v-icon>
              <span class="font-weight-bold">Last events</span>
            </v-card-title>

            <v-card-text class="caption">
              <v-layout>
                <v-flex
                  xs12
                  style="padding: 1rem"
                  v-if="device.rawLastEvents.length > 0"
                  class="text-capitalize"
                >
                  <v-layout
                    v-for="(item, index) in device.rawLastEvents"
                    :key="index"
                    align-center
                  >
                    <v-flex xs3 class="grey--text">
                      {{ item.v.et }}
                    </v-flex>
                    <v-flex xs8>
                      <p>
                        {{ item.v.m }} {{ item.v.l ? " - " + item.v.l : "" }}
                      </p>
                      <p class="grey--text">{{ item.v.msg || "" }}</p>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else>
                  <div
                    class="
                      d-flex
                      transition-fast-in-fast-out
                      grey
                      lighten-4
                      v-card--reveal
                      grey--text
                      text-sm-center
                    "
                    style="
                      height: 100%;
                      width: 100%;
                      opacity: 0.5;
                      position: absolute;
                      margin-top: -1rem;
                    "
                  >
                    <p
                      style="
                        position: absolute;
                        width: 100%;
                        padding-top: 0.5rem;
                      "
                      class="text-sm-center"
                    >
                      No events available
                    </p>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- Map section -->
        <v-flex xs12 style="margin-bottom: 2rem">
          <v-card
            tile
            flat
            class="elevation-1"
            style="
              position: relative;
              text-align: left;
              padding-bottom: 0.4rem;
              width: 100%;
            "
          >
            <v-card-title
              class="subheading"
              style="
                margin-top: 1rem;
                border-style: solid;
                border-width: 0em 0em 0em 0.3em;
                border-color: #ffc107;
                margin-top: -0.1rem;
              "
            >
              <v-icon left>map</v-icon>
              <span class="font-weight-bold">Last known position</span>
            </v-card-title>

            <v-card-text class="caption">
              <v-layout>
                <v-flex xs12 v-if="this.device.rawLastGeolocation.length > 0">
                  <MapView
                    style="z-index: 0; width: 100%"
                    v-on:clickMap="() => {}"
                    v-on:clickMarker="() => {}"
                    v-on:clickPath="() => {}"
                    :markers="markers"
                    :height="'20rem'"
                  />
                </v-flex>
                <v-flex xs12 v-else>
                  <div
                    class="
                      d-flex
                      transition-fast-in-fast-out
                      grey
                      lighten-4
                      v-card--reveal
                      grey--text
                      text-sm-center
                    "
                    style="
                      height: 100%;
                      width: 100%;
                      opacity: 0.5;
                      position: absolute;
                      margin-top: -1rem;
                    "
                  >
                    <p
                      style="
                        position: absolute;
                        width: 100%;
                        padding-top: 0.5rem;
                      "
                      class="text-sm-center"
                    >
                      No geo-position available
                    </p>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- Share device with -->
        <v-flex v-if="!this.device.notOwned" xs12 style="margin-bottom: 2rem">
          <v-card
            tile
            flat
            class="elevation-1"
            style="position: relative; text-align: left; padding-bottom: 0.4rem; width: 100%;"
          >
            <div
              style="
              margin-top: 1rem;
              border-style: solid;
              border-width: 0em 0em 0em 0.3em;
              border-color: #ffc107;
              margin-top: -0.1rem;
            "
            >
              <v-card-title class="subheading">
                <v-icon left>person</v-icon>
                <span class="font-weight-bold"
                  >Share device with other users</span
                >
              </v-card-title>
              <div
                class="caption"
                style="margin-left: 4rem; margin-top: -1rem;"
              >
                Add emails of registered users to share a device with them. They
                will be able to see data and events coming from the device.
              </div>
            </div>

            <v-card-text
              class="caption text-center"
              style="margin: 0 auto; text-align: center;"
            >
              <v-combobox
                v-model="sharedWith"
                label="Users who can access the device data"
                multiple
                chips
                clearable
                deletable-chips
                solo
                small-chips
                hide-selected
                @keydown.enter="onEnter"
              ></v-combobox>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#FFD300"
                style="margin-right: 0.5rem"
                @click="submitSharedWith()"
              >
                <v-icon small style="margin-right: 0.5rem">send</v-icon>Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <!-- Download data -->
        <v-flex xs12 style="margin-bottom: 2rem">
          <v-card
            tile
            flat
            class="elevation-1"
            style="
              position: relative;
              text-align: left;
              padding-bottom: 0.4rem;
              width: 100%;
            "
          >
            <div
              style="
                  margin-top: 1rem;
                  border-style: solid;
                  border-width: 0em 0em 0em 0.3em;
                  border-color: #ffc107;
                  margin-top: -0.1rem;
                "
            >
              <v-card-title class="subheading">
                <v-icon left>map</v-icon>
                <span class="font-weight-bold">Download raw data</span>
              </v-card-title>
              <div class="caption" style="margin-left:4rem;margin-top:-1rem">
                Download daily backup copy of telemetry data sent by the device
              </div>
            </div>
            <v-card-text
              class="caption text-center"
              style="margin:0 auto; text-align:center;"
            >
              <v-date-picker
                color="#39a9dc"
                ref="picker"
                v-model="selectedDate"
                multiple
                min="1950-01-01"
              >
              </v-date-picker>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#FFD300"
                style="margin-right: 0.5rem"
                v-on:click="downloadData()"
              >
                <v-icon small style="margin-right: 0.5rem">send</v-icon>Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import Map from "@/components/MapView";
import {mapState} from "vuex";

export default {
  name: "DeviceDetails",

  data: function() {
    return {
      selectedDate: [],
      markers: [],
      sharedWith: [],
      measuresAvailable: [
        {
          id: "tem",
          label: "Temperature (°C)",
          unit: {
            value: 1,
            label: "°C",
          },
          scalar: true,
          // img: resourcesResolver("telemetry","temperature")
        },
        {
          id: "pre",
          label: "Pressure (hPa)",
          unit: {
            value: 1,
            label: "hPa",
          },
          scalar: true,
          // img: resourcesResolver("telemetry","pressure")
        },
        {
          id: "hum",
          label: "Humidity (%)",
          unit: {
            value: 1,
            label: "o/o",
          },
          scalar: true,
          // img: resourcesResolver("telemetry","humidity")
        },
        {
          id: "acc",
          label: "Accelerometer (mg)",
          unit: {
            value: 0.001,
            label: "g",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          // img: resourcesResolver("telemetry","acc")
        },
        {
          id: "gyr",
          label: "Gyroscope (mdps)",
          unit: {
            value: 0.001,
            label: "dps",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          // img: resourcesResolver("telemetry","gyr")
        },
        {
          id: "mag",
          label: "Magnetometer (mgauss)",
          unit: {
            value: 0.001,
            label: "gauss",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          // img: resourcesResolver("telemetry","mag")
        },
      ],
    };
  },

  props: {
    index: Number,
    values: Object,
  },

  components: {
    MapView: Map,
  },
  computed: {
    ...mapState({
      devices: (state) => state.devices.devices,
      ids: (state) => state.idsSnake,
    }),

    device: function() {
      return this.devices.find((device) => device.id == this.ids[this.index]);
    },
  },

  watch: {
    selectedDate() {
      if (this.selectedDate.length > 2) {
        this.selectedDate.shift();
      }
    },
  },

  mounted() {
    this.markers = this.buildMarkers(this.device.rawLastGeolocation);
    this.sharedWith = this.device.attributes.sharedWithArray;
  },
  methods: {
    buildMarkers: function(geoLocations) {
      let markers = [];
      geoLocations.forEach((geoLocation) => {
        let coordinates = {
          latitude: geoLocation.v.lat,
          longitude: geoLocation.v.lon,
          altitude: geoLocation.v.ele,
        };
        let marker = {
          id: this.device.id,
          coordinates: coordinates,
          htmlContentTooltip: null,
        };
        markers.push(marker);
      });
      return markers;
    },

    deleteDevice: function() {
      if (confirm("Are you sure to delete device " + this.device.id + " ?")) {
        this.$store.dispatch("devices/deleteDevice", this.device);
        this.$emit("deviceDeleted", this.device);
      }
    },

    updateConfigurationDevice: function() {
      let configurationObj = {
        deviceId: this.device.id,
        gatewayId: this.device.attributes.gateway,
        configuration: this.configuration,
      };
      this.$store
        .dispatch("devices/updateConfigurationDevice", configurationObj)
        .then(() => this.$emit("deviceUpdated", this.device.id));
    },

    downloadData: async function() {
      if (this.selectedDate.length > 0) {
        this.selectedDate.sort((a, b) => b - a);
        await this.$store.dispatch("telemetry/downloadRawData", {
          devices: [this.device],
          startTime: new Date(this.selectedDate[0]),
          endTime: new Date(this.selectedDate[this.selectedDate.length - 1]),
        });
      }
    },
    onEnter: function(e) {
      const email = e.target.value.trim();
      if (email && !this.sharedWith.includes(email)) {
        this.sharedWith.push(email);
      }
      e.target.value = ""; // Clear the input manually
    },
    submitSharedWith: async function() {
      const configurationObj = {
        deviceId: this.device.id,
        sharedWith: this.sharedWith,
      };
      await this.$store
        .dispatch("devices/updateConfigurationDevice", configurationObj)
        .then(() => this.$emit("deviceUpdated", this.device.id));
    },
  },
};
</script>
